var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarO = function SvgDefaultAvatarO(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 55.8c8.8 0 15.7-6.6 15.7-15.6 0-8.8-6.6-15.5-15.5-15.5-8.7 0-15.6 6.6-15.6 15.6 0 8.8 6.6 15.5 15.4 15.5zM29.8 38.5c0-5.9 3.3-10.9 9.1-10.9 7.2 0 11.3 7.6 11.3 14.2 0 5.9-3.3 10.8-9.2 10.8-7.1.1-11.2-7.5-11.2-14.1z"
  })));
};
export default SvgDefaultAvatarO;